import { theme } from '../../../theme';
import { parseWidth } from './parseWidth';
import { sumAllAfterIndex, sumAllBeforeIndex } from './sumAll';
export function generateTableCss({ pinnedLeft, pinnedRight, cellWidths, scrollPosition, visible, stripingMode, }) {
    const pinnedLeftStyles = pinnedLeft.map((_, index) => `
    th:nth-child(${index + 1}),
    td:nth-child(${index + 1}) {
      position: sticky;
      left: ${cellWidths ? sumAllBeforeIndex(cellWidths, index + 1) : 0}px;
      z-index: 2;
    }
  `);
    const pinnedRightStyles = pinnedRight.map((_, index) => `
    th:nth-last-child(${index + 1}),
    td:nth-last-child(${index + 1}) {
      position: sticky;
      right: ${cellWidths ? sumAllAfterIndex(cellWidths, cellWidths.length - index) : 0}px;
    }
  `);
    const isLeftShadowVisible = scrollPosition !== 'start' && scrollPosition !== 'none';
    const leftShadow = `
    th:nth-child(${pinnedLeft.length})::after,
    td:nth-child(${pinnedLeft.length})::after {
      position: absolute;
      transform: translate(100%);
      top: 0;
      right: 0;
      bottom: -1px;
      width: 30px;
      content: "";
      pointer-events: none;
      box-sizing: border-box;
      box-shadow: ${isLeftShadowVisible ? 'inset 10px 0 10px -8px rgb(0 0 0 / 25%)' : 'none'};
    }
  `;
    const isRightShadowVisible = scrollPosition !== 'end' && scrollPosition !== 'none';
    const rightShadow = `
    th:nth-last-child(${pinnedRight.length})::after,
    td:nth-last-child(${pinnedRight.length})::after {
      position: absolute;
      transform: translate(-100%);
      top: 0;
      left: 0;
      bottom: -1px;
      width: 30px;
      content: "";
      pointer-events: none;
      box-sizing: border-box;
      box-shadow: ${isRightShadowVisible ? 'inset -10px 0 10px -8px rgb(0 0 0 / 25%)' : 'none'};
    }
  `;
    const stripingRow = `
    tr:nth-child(odd) > td {
      background-color: ${theme.colors.neutral.grey.lightest};
    }

    tr + tr > td {
      border-top: 1px solid ${theme.colors.neutral.grey.base};
    }
  `;
    const stripingNested = `
    tbody:nth-of-type(odd) > tr > td {
      background-color: ${theme.colors.neutral.grey.lightest};
    }

    tbody + tbody > tr:first-child > td {
      border-top: 1px solid ${theme.colors.neutral.grey.base};
    }
  `;
    return `
    grid-template-columns: ${visible.map((col) => parseWidth(col.width)).join(' ')};

    th::after, td::after {
      transition: box-shadow .3s;
    }

    ${pinnedLeft.length > 0 ? pinnedLeftStyles : ''}
    ${pinnedRight.length > 0 ? pinnedRightStyles : ''}

    ${leftShadow}
    ${rightShadow}

    ${stripingMode === 'nested' ? stripingNested : stripingRow}
  `;
}
//# sourceMappingURL=generateTableCss.js.map